import React, { useCallback, useMemo, useRef } from "react";
import DataGrid, {
  Column,
  Editing,
  MasterDetail,
  Paging,
  Summary, GroupItem, GroupPanel, SearchPanel, FilterPanel, FilterRow, FilterBuilderPopup, HeaderFilter, Export
} from "devextreme-react/data-grid";

import { useDispatch, useSelector } from "react-redux";
import {
  postResource,
  updateResource,
  deleteResource,
} from "../../redux/slices/resourceSlice.js";
import { handleNotificationMessage } from "../../utils/notifications.js";
import VendorInvoicePaymentGrid, {
  vendorInvoicePaymentColumns,
} from "./VendorInvoicePaymentGrid.jsx";
import UserCell, { findUsername } from "../generic/UserCell.jsx";
import DateDisplay from "../generic/DateDisplay.jsx";
import VendorCell, { findVendor } from "../generic/VendorCell.jsx";
import CustomSelection from "../generic/CustomSelection.jsx";
import {
  calculateDate,
  fromCustomDate,
  toCustomDate,
} from "../../utils/date.js";
import { DateBox } from "devextreme-react";
import { getUserId } from "../../redux/slices/userSlice.js";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { copyCSVToClipboard } from "../../utils/general.js";
import useResources from "../../hooks/useResources.jsx";
import { numberWithCommas } from "../../utils/strings.js";
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver-es';

let myVendors = null;
const calculateVendorName = (rowData) => {
  
    return findVendor(myVendors, rowData.vendor_id);
  
}
const columns = [
  { dataField: "id", caption: "id", allowEditing: false, width: 50 },
  { dataField: "our_ref", caption: "Our Ref" },
  { dataField: "vendor_ref", caption: "Vendor Ref" },
  {
    dataField: "issue_date",
    caption: "Issue Date",
    type: "date",
    width: 100,
  },
  {
    dataField: "received_date",
    caption: "Received Date",
    type: "date",
    width: 100,
  },
  {
    dataField: "due_date",
    caption: "Due Date",
    type: "date",
    width: 100,
  },
  {
    type: "customSelection",
    dataField: "currency",
    caption: "Currency",
    resourceName: "currencies",
    resourcePath: "currency",
    width: 70,
  },
  {
    //type: "customSelection",
    dataField: "vendor_id",
    valueExpr: "id",
    width: 70,
    caption: "Vendor",
    //resourceName: "vendors",
    //resourcePath: "vendor",
    //cellRender: (data) => <VendorCell data={data} />,
  },
  {
    width: 170,
    caption: "Vendor Name",
    allowSearch: true,
    allowGrouping: true,
    calculateCellValue: calculateVendorName,
  },
  {
    dataField: "debit",
    caption: "Debit",
    cellRender: (rowData) => (
      <div style={{ textAlign: "right" }}>
        {numberWithCommas(parseFloat(rowData.data.debit))}
      </div>
    ),
  },
  {
    dataField: "packing_amt",
    caption: "Packing amount",
    width: 70,
    cellRender: (rowData) => (
      <div style={{ textAlign: "right" }}>
        {numberWithCommas(parseFloat(rowData.data.packing_amt))}
      </div>
    ),
  },
  {
    dataField: "transportation_amt",
    caption: "Transportation amount",
    width: 70,
    cellRender: (rowData) => (
      <div style={{ textAlign: "right" }}>
        {numberWithCommas(parseFloat(rowData.data.transportation_amt))}
      </div>
    ),
  },
  {
    dataField: "credit",
    caption: "Credit",
    cellRender: (rowData) => (
      <div style={{ textAlign: "right" }}>
        {numberWithCommas(parseFloat(rowData.data.credit))}
      </div>
    ),
  },
  {
    dataField: "balance_amt",
    caption: "Balance",
    allowEditing: false,
    cellRender: (rowData) => (
      <div style={{ textAlign: "right" }}>
        {numberWithCommas(parseFloat(rowData.data.balance_amt))}
      </div>
    ),
  },
  {
    dataField: "last_payment_date",
    type: "date",
    caption: "Last payment Date",
    allowEditing: false,
  },
  {
    dataField: "days_between_received_and_payment",
    caption: "Days_between_received_and_payment",
    allowEditing: false,
    width: 60,
  },
  {
    dataField: "user_id",
    caption: "User",
    allowEditing: false,
    cellRender: (data) => <UserCell data={data} />,
  },
];

const resourceName = "vendor-invoice";

const formatData = (data) => {
  return {
    ...data,
    received_date: data.received_date || toCustomDate(),
    issue_date: data.issue_date || toCustomDate(),
    due_date: data.due_date || toCustomDate(),
  };
};

const InvoicesGrid = ({ dataSource = [] }) => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  const userId = useSelector((state) => getUserId(state));
  const { employees, vendors } = useResources();
myVendors = vendors;
  const onInitNewRow = useCallback(
    ({ data }) => {
      //TODO : get name from token
      data.user_id = userId;
    },
    [userId]
  );

  const dataToPaperData = useCallback(
    (data) => ({
      ...data,
      received_date: calculateDate(data.received_date),
      issue_date: calculateDate(data.issue_date),
      due_date: calculateDate(data.due_date),
      user_id: findUsername(employees, data.user_id),
      vendor_id: findVendor(vendors, data.vendor_id),
    }),
    [employees, vendors]
  );

  const exportGrid = useCallback(() => {
    const doc = new jsPDF("l", "pt");
    const docWidth = doc.internal.pageSize.getWidth() - 80;

    const dataFields = columns.map((c) => ({
      dataKey: c.dataField,
      header: c.caption,
    }));

    const paymentsDataFields = vendorInvoicePaymentColumns.map((c) => ({
      dataKey: c.dataField,
      header: c.caption,
    }));

    dataSource
      .map((data) => {
        return dataToPaperData(data);
      })
      .forEach((data) => {
        doc.autoTable({
          styles: { cellWidth: docWidth / dataFields.length, halign: "center" },
          body: [data],
          columns: dataFields,
        });

        if (
          data.vendor_invoice_payments &&
          data.vendor_invoice_payments.length > 0
        )
          doc.autoTable({
            styles: {
              cellWidth: docWidth / paymentsDataFields.length,
              halign: "center",
            },
            body: data.vendor_invoice_payments,
            columns: paymentsDataFields,
          });
      });

    doc.save("Supplier-Invoices.pdf");
  }, [dataSource, dataToPaperData]);

  const onValueChanged = useCallback((rowIndex, value, dataField) => {
    gridRef.current.instance.cellValue(rowIndex, dataField, value);
  }, []);

  const onSaving = useCallback(
    (e) => {
      e.changes.forEach((change) => {
        switch (change.type) {
          case "insert":
            dispatch(
              postResource({
                path: `${resourceName}`,
                data: formatData(change.data),
              })
            ).then(({ payload }) => {
              const { path, error } = payload;
              const data = payload.data;
              handleNotificationMessage(path, data?.id, error, change.type);
              if (!error) e.cancel = true;
              e.component.cancelEditData();
            });
            return;
          case "update":
            dispatch(
              updateResource({
                path: resourceName,
                id: change.key.id,
                data: change.data,
              })
            ).then(({ payload }) => {
              if (e.cancel != null) {
                e.cancel = true;
                e.component.cancelEditData();
              }

              const { path, id, error } = payload;

              handleNotificationMessage(path, id, error, change.type);
            });
            return;
          case "remove":
            dispatch(
              deleteResource({ path: resourceName, id: change.key.id })
            ).then(({ payload }) => {
              e.cancel = true;
              e.component.cancelEditData();

              const { path, id, error } = payload;

              handleNotificationMessage(path, id, error, change.type);
            });
            return;
          default:
            return;
        }
      });

      e.cancel = true;
    },
    [dispatch]
  );

  const onToolbarPreparing = useCallback(
    (e) => {
      e.toolbarOptions.items.unshift(
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "pdffile",
            hint: "Download Pdf",
            onClick: exportGrid,
          },
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "copy",
            hint: "Copy CSV",
            onClick: () =>
              copyCSVToClipboard(
                dataSource.map((data) => dataToPaperData(data))
              ),
          },
        }
      );
    },
    [exportGrid, dataSource, dataToPaperData]
  );

  const onRowValidating = useCallback((e) => {
    if (e.newData.currency && e.newData.our_ref && e.newData.vendor_id) {
      e.isValid = true;
    } else {
      e.isValid = false;
      e.errorText = "Some fields are required";
    }
  }, []);

  const onExporting = (e) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
      });
    });
    e.cancel = true;
  };
/*   const filterBuilderPopupPosition = {
    of: window,
    at: 'top',
    my: 'top',
    offset: { y: 10 },
  }; */

  //TODO: custom expand row
  //https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/MasterDetailAPI/React/Light/

  
  return useMemo(
    () => (
      <React.Fragment>
        <DataGrid
          id="gridContainer"
          rowAlternationEnabled={true}
          ref={gridRef}
          dataSource={dataSource}
          allowColumnReordering={true}
          showBorders={true}
          onRowValidating={onRowValidating}
          onSaving={onSaving}
          onInitNewRow={onInitNewRow}
          onToolbarPreparing={onToolbarPreparing}
          onExporting={onExporting}
        >
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          
          <HeaderFilter visible={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} />
          
          <Paging enabled={true} />
          <Editing
            mode="batch"
            allowUpdating={true}
            allowAdding={true}
            allowDeleting={true}
            allowSorting={false}
          />
          {columns.map((column) => {
            if (column.type === "customSelection")
              return (
                <Column
                  key={column.dataField}
                  dataField={column.dataField}
                  caption={column.caption}
                  width={column.width}
                  cellRender={column.cellRender}
                  editCellRender={(cell) => {
                    return (
                      <CustomSelection
                        valueExpr={column.valueExpr}
                        resourceName={column.resourceName}
                        resourcePath={column.resourcePath}
                        defaultValue={cell.data[column.dataField]}
                        dataSource={column.dataSource}
                        handleChange={(e) =>
                          onValueChanged(
                            cell.rowIndex,
                            e.value,
                            column.dataField
                          )
                        }
                      />
                    );
                  }}
                />
              );
            else if (column.type === "date")
              return (
                <Column
                  key={column.dataField}
                  dataField={column.dataField}
                  caption={column.caption}
                  width={column.width}
                  cellRender={DateDisplay}
                  editCellRender={(cell) => (
                    <DateBox
                      displayFormat="dd/MM/yyyy"
                      onValueChanged={(e) =>
                        onValueChanged(
                          cell.rowIndex,
                          toCustomDate(e.value),
                          column.dataField
                        )
                      }
                      value={fromCustomDate(cell.data[column.dataField])}
                    />
                  )}
                />
              );
            return (
              <Column
                key={column.dataField}
                cellRender={column.cellRender}
                dataField={column.dataField}
                caption={column.caption}
                width={column.width}
                allowEditing={column.allowEditing}
                allowSorting={false}
                allowSearch={true}
                allowGrouping={true}
                allowHeaderFiltering={true}
                calculateCellValue={column.calculateCellValue}
              />
            );
          })}
          <MasterDetail
            enabled={true}
            component={({ data }) => <VendorInvoicePaymentGrid data={data} />}
          />

          <Summary>
          <GroupItem
              column="balance_amt"
              summaryType="sum"
              valueFormat="currency"
              displayFormat="Balance: {0}" />
          
          </Summary>
          <Export enabled={true} allowExportSelectedData={false} />
        </DataGrid>
        
      </React.Fragment>
    ),
    [
      dataSource,
      onInitNewRow,
      onRowValidating,
      onSaving,
      onToolbarPreparing,
      onValueChanged,
    ]
  );

  
};
export default InvoicesGrid;
